// spinnerManager.js
let activeRequests = 0;
let spinnerTimeout = null;
let timeoutMs = 30000;

export function showSpinner(store) {
  activeRequests++;
  if (activeRequests === 1) {
    store.dispatch('showSpinner');
  }
  
  // 기존 타이머 초기화
  clearTimeout(spinnerTimeout);
  
  // 안전 타이머 (API 누락으로 hide 안될 경우 대비)
  spinnerTimeout = setTimeout(() => {
    if (activeRequests > 0) {
      console.warn('[SpinnerManager] Force hiding spinner after timeout');
      activeRequests = 0;
      store.dispatch('hideSpinner');
    }
  }, timeoutMs);
}

export function hideSpinner(store) {
  if (activeRequests > 0) {
    activeRequests--;
  }
  
  // 모든 요청 완료 시 스피너 종료
  if (activeRequests === 0) {
    clearTimeout(spinnerTimeout);
    store.dispatch('hideSpinner');
  }
}
